import React, { useEffect, useState } from "react";
import { appAxios } from "../../axios/axios";
import { SelectWrapper } from "../Common/Ui/SelectWrapper";

interface IOption {
  label: string;
  value: string;
}

export const AirportSelector: React.FC<{
  className?: string;
  label?: string;
  options?: Array<IOption>;
  value?: string | undefined;
  controlClassName?: string;
  onChange: (value: string) => void;
}> = (props) => {
  const [searchedAirports, setSearchedAirports] = useState<Array<string>>([]);
  const [airportOptions, setAirportOptions] = useState<
    {
      label: string;
      value: string;
    }[]
  >([]);
  const [inputState, setInputState] = React.useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    getAirports();
  }, [inputState, searchedAirports, props.value]);

  const getAirports = async () => {
    // flightApi/api
    setIsLoading(true);
    const response = await appAxios("/flightApi/api/getAirports", {
      method: "POST",
      data: {
        searchBy: inputState,
        searchQuery: inputState,
        cityCodes: [...searchedAirports, props.value],
      },
      baseURL: "https://1.landarrangement.com",
    });
    const airports = response?.data?.result.airports;
    const airportsToSave = airports?.length
      ? airports?.map((city: any) => {
          return {
            label: `${city.cityName} (${city.cityCode})`,
            value: city.cityCode,
          };
        })
      : [];
    setAirportOptions(airportsToSave);
    setIsLoading(false);
  };

  return (
    <>
      {props.label && <label>{props.label}</label>}
      <SelectWrapper
        onChange={(val) => {
          if (val?.value) {
            setSearchedAirports([...searchedAirports, val?.value]);
          }
          props.onChange(val?.value || "");
        }}
        value={props.value}
        onInputChange={(val) => {
          if (val.length === 0) {
            return;
          }
          setInputState(val);
        }}
        options={airportOptions}
        controlClassName="location-select"
        inputClassName="input-placeholder"
        isLoading={isLoading}
      />
    </>
  );
};
